
import StateContext from '../../../context/State';
import { useContext, useState, useEffect } from "react";
import { Badge } from "react-bootstrap";
import PortalService from '../../../services/portal.service';
import { PropertyAttributesData } from '../../../data/index';
import { defaultPropertyAttributeState } from '../../../data';
import { PropertyAttributes } from '../../../types';


const PurchasePropertyDetails = () => {

    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const [propertyAttributesState, setPropertyAttributesState] = useState<PropertyAttributes>(defaultPropertyAttributeState);
    const [mortgageFile, setMortgageFile] = useState<boolean>(false);

    // eslint-disable-next-line
    useEffect(() => { getPropertyAttributesState(); getFileType(); }, []);
    const getFileType = async (): Promise<void> => {
        try {
            const fileTypeResponse = await portalService.getFileInfo(state.appId);

            if (fileTypeResponse) {
                if (fileTypeResponse.file.clients.length !== 0) {
                    setMortgageFile(true);
                }
            }

        } catch (e) {
            console.log('unable to get file type', e)
        }
    }

    const getPropertyAttributesState = async (): Promise<void> => {
        const response = await portalService.getPropertyAttributesState(state.portalId);
        const initalPropertyAttributesState = JSON.parse(response.PurchasePropertyDetails);
        if (initalPropertyAttributesState) {
            if (checkIfAllFalse(initalPropertyAttributesState)) {
                setPropertyAttributesState(initalPropertyAttributesState);
            } else {
                setPropertyAttributesState(null);
            }
        } else {
            setPropertyAttributesState(null);
        }
    }

    const checkIfAllFalse = (initalPropertyAttributesState): boolean => {
        for (const key in initalPropertyAttributesState) {
            if (initalPropertyAttributesState[key]) { return true }
        }
        return false;
    }

    return (
        <>
            {!mortgageFile && propertyAttributesState &&
                <>
                    <h3>Property Attributes</h3>
                    {PropertyAttributesData.map((propertyAttribute) => {
                        if (propertyAttributesState[propertyAttribute.value]) {
                            return (
                                <Badge
                                    key={propertyAttribute.name + 'badge'}
                                    pill
                                    className='badge-attribute'
                                    bg='info'
                                    text='dark'
                                >
                                    <i
                                        className={propertyAttribute.icon}
                                    />
                                    {propertyAttribute.name}
                                </Badge>
                            );
                        }else{
                            return null
                        }
                    })}
                </>
            }
        </>
    )
}

export default PurchasePropertyDetails;